import type { ComboboxOption } from "@src/sharedComponents/Combobox/Combobox";
import type { AutocompleteOption } from "@src/sharedComponents/Dropdown/Dropdown";

export const UNKNOWN_USER = "Unknown User";
export const UNKNOWN_GROUP = "Unknown Group";
export const UNKNOWN_VALUE = "-";

export type EnhancedAutocompleteOption<
  T extends string | boolean | undefined = string
> = AutocompleteOption & { value: T };

export type EnhancedAutocompleteOptionV2<
  T extends string | boolean | undefined = string
> = AutocompleteOption & { value: T } & Pick<ComboboxOption<string>, "meta">;

export type WithGroupMeta = { meta: { group: string } };
